import {
  type ILogger,
  type LoggerFunction,
  LoggersManager,
} from '@zajno/common/logger/index';

const { logger, setMode, createLogger } = new LoggersManager().expose();

export { createLogger, setMode as setLoggerMode };

export type { LoggerFunction, ILogger };
export type { ILoggerSwitchable } from '@zajno/common/logger/types';

export default logger;
